import React from 'react';
import { Helmet } from 'react-helmet';

const PageTitle = ({ title = '', additional = '', init = '' }) => (
  <Helmet>
    <title>
      {init}
      {init.length > 0 && title.length > 0 ? ` - ${title}` : title}
      {(init.length > 0 || title.length > 0) && additional.length > 0 ? ` - ${additional}` : additional}
    </title>
  </Helmet>
);

export default PageTitle;
